import SchoolOptionsController from 'linced-app/controllers/school-options';

export default class HeroSupportController extends SchoolOptionsController {}
